/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { IColumn } from 'types'
import { format } from 'date-fns'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'redux/store'
import { Button, Tooltip } from '@mui/material'
import { setBenchmark, setBenchmarkStudent } from 'redux/ui/benchmarksUI'
import { FaEye } from 'react-icons/fa'
import { actionIcon, eyeIcon, STATUS_COLORS } from 'utils/customizedTheme'


export const useTableModel = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch<AppDispatch>()


  const handleDateFormat = useCallback(
    (cellValue: string) => (cellValue ? format(new Date(cellValue), 'dd-MM-yyyy HH:ii') : ''),
    [],
  ) 
  const handleBenchmarkFormat = useCallback((cellValue: string, row: any) => `${row.benchmark?.display_code} ${row.benchmark?.title}`, [])

  const handleStatusFormat = (cellValue: string, row: any) => 
    <span style={{ 
      padding: '6px 14px',
      borderRadius: '10px',
      color: '#fff',
      textTransform: 'uppercase',
      fontSize: '14px',
      fontWeight: 600,
      backgroundColor: row.status in STATUS_COLORS ? STATUS_COLORS[row.status] : '',
    }}>{t(`zpd-tags.${row.status}`)}</span>


    const handleActionsFormat = (cellValue: string, row: any) => 
          <Tooltip title={`${t('common.view')}`} arrow placement='top'>
            <Button
              onClick={() => {
                  dispatch(setBenchmarkStudent(row.student_id))
                  dispatch(setBenchmark(row.benchmark.id))
              }}
              variant='outlined'
              color={'primary'}
              disableElevation
              sx={{ ...actionIcon, ...eyeIcon }}
            >
              <FaEye />
            </Button>
          </Tooltip>
    

  const columns: IColumn[] = [

    {
      title: `${t('common.student')}`,
      field: 'student',
      order: true,
      width: '15%',
    },
    {
      title: `${t('common.benchmark')}`,
      field: 'benchmark',
      order: true,
      width: '35%',
      format: handleBenchmarkFormat,
    },
    {
      title: `${t('common.zpd-tag')}`,
      field: 'status',
      order: true,
      width: '15%',
      format: handleStatusFormat,
    },
    {
      title: `${t('common.assessed-by')}`,
      field: 'reporter',
      order: true,
      width: '15%',
    },
    {
      title: `${t('common.assessed-on')}`,
      field: 'created_at',
      order: true,
      width: '15%',
      format: handleDateFormat,
    },
    {
      title: '',
      field: '',
      width: '5%',
      align: 'end',
      order: false,
      format: handleActionsFormat,
    },
  ]

  return columns
}